import React from "react";
import "./style.css";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="overlap-group">
        <div className="line" />

        <img className="image" alt="Image" src="/img/image-9-1.png" />
      </div>

      <div className="logo">
        <img className="img" alt="Logo" src="/img/logo-3-1.png" />

        <div className="text-wrapper">Build Start</div>
      </div>

      <div className="social-media">
        <div className="div">Social Media</div>

        <div className="twitter">
          <img className="icon" alt="Icon" src="/img/icon.png" />
        </div>

        <div className="instagram">
          <img className="icon-2" alt="Icon" src="/img/icon-2.png" />
        </div>

        <div className="youtube">
          <img className="icon-3" alt="Icon" src="/img/icon-3.png" />
        </div>

        <div className="linkedin">
          <img className="icon-4" alt="Icon" src="/img/icon-4.png" />
        </div>
      </div>

      <div className="quick-links">
        <div className="text-wrapper-2">Quick Links</div>

        <p className="text-wrapper-3">
          For Home Owners
          <br />
          For Professionals
          <br />
          Jobs
          <br />
          Social Media
        </p>

        <div className="prices-education">
          Prices
          <br />
          Education Resources
          <br />
          Contact
        </div>
      </div>

      <div className="directory">
        <div className="text-wrapper-2">Directory</div>

        <div className="text-wrapper-3">
          Airconditioning
          <br />
          Builders
          <br />
          Concreters
          <br />
          Design
        </div>

        <div className="estimators-gardeners">
          Estimators
          <br />
          Gardeners
          <br />
          More......
        </div>
      </div>

      <div className="resources">
        <div className="text-wrapper-2">Resources</div>

        <div className="text-wrapper-3">
          Terminology
          <br />
          Flow Charts
          <br />
          Design Tips
          <br />
          How tos
        </div>

        <div className="support-our-process">
          Support
          <br />
          Our Process
          <br />
          Resource library
        </div>
      </div>

      <div className="line-2" />

      <div className="line-3" />

      <div className="line-4" />

      <p className="p">© 2024 Build Start. All rights reserved.</p>
    </footer>
  );
};
